export class WorldAssignmentErrorCodes {
    public static WORLD_ASSIGNMENT_FAILED_TO_INITIALIZE: number = 100001;
    public static BRANCHES_FAILED_TO_LOAD: number = 100002;
    public static BRANCHES_FAILED_TO_INITIALIZE: number = 100003;
    public static COUNTRY_FAILED_TO_LOAD: number = 100004;
    public static COUNTRY_FAILED_GEOIP: number = 100005;
    public static NETWORK_FAILED_TO_LOAD: number = 100006;
    public static ZONE_CAPACITIES_FAILED_TO_LOAD: number = 100007;
    public static UNKNOWN_ERROR: number = 100008;
}
